module.exports = {"product":"Planetary Computer Pro (Preview)"}